
import { Component, Prop, Vue } from 'vue-property-decorator'

import OrderTypeCard from './OrderTypeCard.vue'
import { DotationOrderForm, OrderCmdType } from '../types/dotationOrderForm'

@Component({
  name: 'StepOrderType',
  components: { OrderTypeCard }
})
export default class extends Vue {
  @Prop({ required: true }) form!: DotationOrderForm

  selectType(type: OrderCmdType): void {
    this.form.cmdType = type
  }
}
